import React, { useState } from 'react'
import { Box, Typography } from '@mui/material';
import { Room1, Room, cover, Fhall, Cot } from "../../../../utils/assests/images/image";
import Marquee from "react-fast-marquee";
const styles = {
    sliderimg: {
        width: '250px',
        height: '250px',
        margin: 5,
        objectFit: 'cover'
    },
    text: {
        fontSize: { xl: 26, lg: 26, md: 20, sm: 18, },
        color: '#000',
        textAlign: 'center'
    },
    label: {
        fontSize: { xl: 22, lg: 22, md: 18, sm: 16, },
        color: '#000',
        textAlign: 'center'
    },
}

export default function RoomsGallery() {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: { xl: 'row', lg: 'row', md: 'row', sm: 'column', xs: 'column' } }}>
            <Box sx={{ display: 'flex', width: { xl: '30%', lg: '30%', md: '50%', sm: '100%', xs: '100%' }, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <Typography sx={styles.text} >Rooms &#38; Cottages</Typography>
                <Typography sx={styles.label}>Our brick rooms and pool side cottages will provide a cozy and comfortable stay for your families and friends.</Typography>
            </Box>
            <Box sx={{ display: 'flex', width: { xl: '70%', lg: '70%', md: '50%', sm: '100%', xs: '100%' }, zIndex: -3 }}>
                <Marquee

                    speed={50}
                    gradientWidth='10%'
                >
                    <img src={Room} style={styles.sliderimg} alt='Room1'/>
                    <img src={Cot} style={styles.sliderimg} alt='Room2'/>
                    <img src={cover} style={styles.sliderimg} alt='Room3'/>
                    <img src={Room1} style={styles.sliderimg} alt='Room4'/>
                    <img src={Fhall} style={styles.sliderimg} alt='Room5'/>
                    <img src={Cot} style={styles.sliderimg} alt='Room6'/>
                </Marquee>
            </Box>

        </Box>

    )
}
